module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-600.5c0fa410.woff2";